import { num } from '../finance/data'
import { KpiSkeleton } from '../components/ui'

/** Вкладки разделов на узком экране — та же разметка, что у финансового блока. */
export function SectionTabs({
  items,
  onGo,
  label,
}: {
  items: Array<{ path: string; short: string; active: boolean }>
  onGo: (path: string) => void
  label: string
}) {
  if (items.length < 2) return null
  return (
    <nav className="fin-tabs" aria-label={label}>
      {items.map((item) => (
        <a
          key={item.path}
          href={item.path}
          className={`fin-tab${item.active ? ' fin-tab--active' : ''}`}
          aria-current={item.active ? 'page' : undefined}
          onClick={(event) => {
            event.preventDefault()
            onGo(item.path)
          }}
        >
          {item.active && <span className="fin-tab__pill" aria-hidden="true" />}
          <span className="fin-tab__text">{item.short}</span>
        </a>
      ))}
    </nav>
  )
}

/** Пока не пришли описания отчётов: геометрия как у раздела — карточки и блок. */
export function BlockSkeleton({ kpis = 4 }: { kpis?: number }) {
  return (
    <div className="fin-stack" aria-busy="true" aria-label="Загрузка">
      <div className={`kpi-grid kpi-grid--n${Math.min(kpis, 4)}`}>
        {Array.from({ length: kpis }, (_, index) => (
          <KpiSkeleton key={index} index={index} />
        ))}
      </div>
      <div className="skeleton" style={{ height: 320, borderRadius: 'var(--radius-lg)' }} />
    </div>
  )
}

/** Подпись значения измерения: пустое значение называется словами, а не прочерком. */
export function labelOr(value: unknown, empty: string): string {
  const text = value === null || value === undefined ? '' : String(value).trim()
  return text || empty
}

/** Строки по убыванию показателя, без нулевых. */
export function ranked(rows: Record<string, unknown>[] | undefined, key = 'revenue'): Record<string, unknown>[] {
  return [...(rows ?? [])].filter((row) => num(row[key]) !== 0).sort((a, b) => num(b[key]) - num(a[key]))
}

export function hasMetric(columns: Array<{ key: string }> | undefined, key: string): boolean {
  return columns?.some((column) => column.key === key) ?? false
}
